import "./Loader.scss";

const Loader = () => <div className="Loader"/>;
export default Loader;
